import React from 'react';

const BookingContextMenu = ({ bookUnbook, bookedFlag }) => (
  bookedFlag
    ? <div className="context-menu__list-item" onClick={bookUnbook}>Unbook</div>
    : <div className="context-menu__list-item" onClick={bookUnbook}>Book</div>
);
export default BookingContextMenu;
